import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overflow-auto pb-5" }
const _hoisted_2 = { class: "notice d-flex bg-light-danger rounded border-danger border border-dashed min-w-lg-600px flex-shrink-0 p-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-exclamation icon-3 text-danger" })
], -1)
const _hoisted_4 = { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }
const _hoisted_5 = { class: "mb-3 mb-md-0 fw-semibold" }
const _hoisted_6 = { class: "text-gray-900 fw-bold" }
const _hoisted_7 = { class: "fs-6 text-gray-700 pe-7" }
const _hoisted_8 = {
  key: 0,
  href: "#",
  class: "btn btn-danger px-6 align-self-center text-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString($props.label), 1),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        ($props.ShowAction)
          ? (_openBlock(), _createElementBlock("a", _hoisted_8, "Proceed"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}